import React, { lazy } from "react";
import { Loader } from "../root/loader";
const Dashboard = lazy(() => import("./components/dashboard"));

export const dashboard = () => [
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/",
            element: (
                <Loader>
                    <Dashboard />
                </Loader>
            )
        }
    }
];
